import { render, staticRenderFns } from "./leasonTemplate.vue?vue&type=template&id=10d3a044&scoped=true&"
import script from "./leasonTemplate.vue?vue&type=script&lang=js&"
export * from "./leasonTemplate.vue?vue&type=script&lang=js&"
import style0 from "./leasonTemplate.vue?vue&type=style&index=0&id=10d3a044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d3a044",
  null
  
)

export default component.exports